<template>
  <div id="app">
    <router-view v-if="$route.meta.onboardingLayout" />
    <container
      v-else
      :show-header-menu-and-footer="$route.meta.showHeaderMenuAndFooter">
      <router-view />
    </container>
  </div>
</template>

<script>
import Container from '@/components/Container'

export default {
  name: 'App',
  components: {
    Container
  },
  created () {
    this.$store.dispatch('async/syncLoopback')
  }
}
</script>

<style lang="scss">
@import '/assets/scss/theme.scss';
@import '../node_modules/icon-kit/dist/css/iconkit.min.css';
</style>



// WEBPACK FOOTER //
// src/App.vue